import QGC       from '@/pages/QGC'
export default [
    {
        path: '/QGC', 
        name: 'QGC',
        component: QGC,
    }
]
